// import external dependencies
import AOS from 'aos';

var __svg__ = { path: '../icon/*.svg', name: 'images/[hash].logos.svg' };
require('webpack-svgstore-plugin/src/helpers/svgxhr')(__svg__);

// Import everything from autoload
import "./autoload/_bootstrap.js";

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import singleProduct from './routes/single-product';
import woocommerceCart from './routes/woocommerce-cart';
import woocommerceCheckout from './routes/woocommerce-checkout';
import woocommerceAccount from './routes/woocommerce-account';
import templateFindOurProducts from './routes/template-find-our-products';
import taxProductCat from './routes/tax-product_cat';
import postTypeArchiveProduct from './routes/post-type-archive-product';
import single from './routes/single';
//import blog from './routes/blog';
/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // Listing product
  taxProductCat,
  postTypeArchiveProduct,
  // Product info
  singleProduct,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  // Cart
  woocommerceCart,
  // Checkout
  woocommerceCheckout,
  // Account
  woocommerceAccount,
  // Find our products
  templateFindOurProducts,
  // Blog
  //blog,
  single,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents())
  var $domElements = [jQuery('.blog-nav li > a, .blog-nav li > .main_img'), jQuery('.blog-content article')];
  var countAnim = 0;

  $domElements.forEach(function(ell, ii) {
    var delayAnim = 0;

    Array.prototype.forEach.call(ell, el => {

      if(countAnim != ii) {
        countAnim = ii;
        delayAnim = 0;
      } else {
        delayAnim = delayAnim + 100;
      }
      el.setAttribute('data-aos-delay', delayAnim);
      el.setAttribute('data-aos', 'fade-up');
      el.setAttribute('data-aos-anchor-placement', 'top-bottom');
    });
  });
jQuery(window).on('load', () => AOS.init({delay: 0, duration: 500}) );



// WEBPACK FOOTER //
// ./scripts/main.js